// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"mobile-phone-control__container___KXivN"};
    if(module.hot) {
      // 1686088255695
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  